import router from "../router";

const BROADCAST_CHANNEL = "callfinder-ui-global";
const BROADCAST_EVENT_PREFIX = "BROADCAST.";
const ROOT_PAGE_SIGNAL = 1;
const CHILD_PAGE_SIGNAL = 2;

const BROADCAST_ACTION_TYPES = [
  process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA,
  process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA,
  process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA,
  process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA,
  process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA,
  process.env.VUE_APP_BROADCAST_SC_CALL_TASK_LIST_DATA,
  process.env.VUE_APP_BROADCAST_TASK_SUMM_LIST_DATA,
  process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE
];

const BROADCAST_ACTIONS_TASK_SUMMARY = [
  process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA,
  process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA,
  process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA,
  process.env.VUE_APP_BROADCAST_TASK_SUMM_LIST_DATA,
   process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE
];

// these are the routes and associated actions that can be broadcasted
const ROUTE_ACTION_ASSOCIATIONS = {
  "task-summary": [
    process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA,
    process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA,
    process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE
  ],
  "task-summary-user-agent": BROADCAST_ACTIONS_TASK_SUMMARY,
  "task-summary-user-agents":BROADCAST_ACTIONS_TASK_SUMMARY,
  "task-summary-all-user-agent": BROADCAST_ACTIONS_TASK_SUMMARY,
  "task-summary-all-user-all-agents": BROADCAST_ACTIONS_TASK_SUMMARY,
  "scorecards-v2-calls": [
    process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA,
    process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA,
    process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA,
    process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA,
    process.env.VUE_APP_BROADCAST_SC_CALL_TASK_LIST_DATA,
  ]
};

// in some cases, we only want to broadcast the action of the data is loaded in the child page
const LOADING_STATUS_ACTION_MAP = {};
LOADING_STATUS_ACTION_MAP[process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA] =
  "scorecardTasks/scorecardTaskAggregateDataLoadingStatus";
LOADING_STATUS_ACTION_MAP[process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA] =
  "guidance/guidanceSessionListLoadingStatus";
LOADING_STATUS_ACTION_MAP[process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA] =
  "scorecardTasks/guidanceTaskListLoadingStatus";

const broadcastChannelPlugin = store => {
  store.broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL);

  store.broadcastChannel.onmessage = event => {
    if (event.data && event.data.action) {
      if (
        ROUTE_ACTION_ASSOCIATIONS[router.currentRoute.name] &&
        ROUTE_ACTION_ASSOCIATIONS[router.currentRoute.name].includes(
          event.data.action
        )
      ) {
        let pkg = {
          signal: CHILD_PAGE_SIGNAL,
          action: event.data.action
        }

        if(event.data.hasOwnProperty('payload')) pkg.payload = event.data.payload

        // if the data needs to be loaded, make sure it is loaded in the child page otherwise just create the broadcast action
        if (
          !LOADING_STATUS_ACTION_MAP[event.data.action]
          || (LOADING_STATUS_ACTION_MAP[event.data.action] &&
          store.getters[LOADING_STATUS_ACTION_MAP[event.data.action]] ==
            "loaded"
        )) {
          store.dispatch("broadcast/createBroadcastAction", pkg);
        }
      }
    }
  };

  store.watch(
    () => store.state.broadcast.broadcastActionList,
    broadcastActionList => {
      store.state.broadcast.broadcastActionList.forEach(broadcastEvent => {
        let action = broadcastEvent.action;

        if (
          broadcastEvent &&
          broadcastEvent.signal == ROOT_PAGE_SIGNAL &&
          BROADCAST_ACTION_TYPES.includes(action)
        ) {
          // dispatch the action on the current page and then pass it to the broadcast channel to refresh other pages as needed
          if (broadcastEvent.refreshRootPage) {
            const index = action.indexOf(BROADCAST_EVENT_PREFIX);
            let vuexAction = action.substring(
              index + BROADCAST_EVENT_PREFIX.length
            );
            store.dispatch(vuexAction, broadcastEvent.payload);
          }

          // broadcast to non-primary pages...
          store.broadcastChannel.postMessage({
            action: action,
            payload: broadcastEvent
          });

          store.commit(
            "broadcast/SPLICE_BROADCAST_ACTION_LIST",
            broadcastEvent
          );
        }
      });
    },
    {
      deep: true
    }
  );
};

export default broadcastChannelPlugin;
